// extracted by mini-css-extract-plugin
module.exports =  {"titleInput":"titleInput_n1XoYMPT","centered":"centered_pjvBTIR0","subTitleInput":"subTitleInput_jcvDjZUf","placeholder":"placeholder_QJGJL161"};